import styled from 'styled-components';

import {
  Menu,
  MenuItem,
  IconButton,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { COLOR } from 'assets/styles/colors';

export const Header = styled.header`
  z-index: 10;
  position: fixed;
  top: 0;
  width: 100%;
  padding: 10px;
  background-color: ${COLOR.WHITE_1};
  a {
    color: inherit;
    text-decoration: none;
  };
`;

export const MenuList = styled.ul`
  display: flex;
  align-items: center;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1152px;
  margin: 0 auto;
`;

export const StyledIcon = withStyles({
  root: {
    padding: 5,
  },
  label: {
    '& > svg': {
      width: 40,
      height: 40,
    },
  },
})(IconButton);

export const StyledMenuItem = withStyles({
  root: {
    padding: '2px 18px',

    '& button': {
      width: 160,
      fontSize: 18,
    },

    '& .MuiButton-outlined': {
      backgroundColor: 'transparent',
    },

    '& .MuiButton-outlined:hover': {
      boxShadow: 'none',
      backgroundColor: 'transparent',
    },

    '& a': {
      textDecoration: 'none',
      color: 'inherit',
    },
  },
})(MenuItem);

export const StyledMenu = withStyles((theme) => ({
  paper: {
    width: 196,
    right: 0,
    left: 'auto !important',
    marginTop: 60,
    borderRadius: '6px 0 0 6px',
    // Tablet-Notebook
    [theme.breakpoints.up('xl')]: {
      right: '15%',
    },
  },
}))(Menu);
